
// validatePhone and validateEmail functions are removed as their logic is now centralized
// in src/utils/validationRules.ts (isPhoneValid, isEmailValid)
// and consumed by src/components/portfolio/settings/utils/validationUtils.ts for message-returning versions.

// Website validation - Accepts URLs with or without protocol
export function validateWebsite(website: string): boolean {
  // Check if it's already a valid URL
  try {
    new URL(website);
    return true;
  } catch (e) {
    // If not a valid URL, check if it would be valid with https:// prepended
    try {
      new URL(`https://${website}`);
      return true;
    } catch (e) {
      return false;
    }
  }
}

// Format phone number to (123) 456-7890 format
export function formatPhoneNumber(phoneNumber: string): string {
  // Remove all non-digits
  const cleaned = phoneNumber.replace(/\D/g, '');
  
  // Check if the input is of correct length
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  
  return phoneNumber; // Return original if not 10 digits
}
